export const contactNumber = '6281222667763';

export const validatePilotForm = (values) => {
  const errors = {};
  if (!values.name.trim()) errors.name = 'Enter your name.';
  if (!values.email.trim()) errors.email = 'Enter your business email.';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) errors.email = 'Enter a valid email address.';
  if (!values.business.trim()) errors.business = 'Enter your business name.';
  if (!values.businessType.trim()) errors.businessType = 'Enter your business type.';
  if (!values.need.trim()) errors.need = 'Describe one workflow you want to improve.';
  return errors;
};

export const buildPilotSummary = (values) => [
  'Hello Jupiter Cosmic, I would like to discuss a pilot.',
  '',
  `Name: ${values.name}`,
  `Business email: ${values.email}`,
  `Business name: ${values.business}`,
  `Business type: ${values.businessType}`,
  `Product interest: ${values.product}`,
  `Workflow to improve: ${values.need}`,
].join('\n');

export const buildWhatsAppUrl = (values) => `https://wa.me/${contactNumber}?text=${encodeURIComponent(buildPilotSummary(values))}`;
